import { Link, useNavigate } from "react-router-dom";
import useUserStore from "../store/userStore";
import { useLocation } from "react-router-dom";
import "./NavBar.css";

const NavBar = () => {
  const navigate = useNavigate();
  const token = useUserStore((state) => state.token);
  const isAdmin = useUserStore((state) => state.isAdmin);
  const setToken = useUserStore((state) => state.setToken);
  const setDestinyRoute = useUserStore((state) => state.setDestinyRoute);

  const location = useLocation();

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img
            src="/logo_texto_lateral.png"
            alt="PokeLeader Logo"
            style={{ height: "24px", width: "auto" }}
            className="me-2"
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li
              className={
                location.pathname === "/" ? "nav-item active" : "nav-item"
              }
            >
              <Link className="nav-link" to="/">
                Home
                {location.pathname === "/" && (
                  <span className="sr-only">(current)</span>
                )}
              </Link>
            </li>
            <li
              className={
                location.pathname === "/leaderboard"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/leaderboard">
                Leaderboard
                {location.pathname === "/leaderboard" && (
                  <span className="sr-only">(current)</span>
                )}
              </Link>
            </li>

            <li
              className={
                location.pathname.toLowerCase() === "/trainers"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/trainers">
                Trainers
                {location.pathname.toLowerCase() === "/trainers" && (
                  <span className="sr-only">(current)</span>
                )}
              </Link>
            </li>

            <li
              className={
                location.pathname === "/community"
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to="/community">
                Community
                {location.pathname === "/community" && (
                  <span className="sr-only">(current)</span>
                )}
              </Link>
            </li>

            {token !== "" && (
              <>
                {/*<li
                  className={
                    location.pathname === "/cart"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/cart">
                    Cart
                    {location.pathname === "/cart" && (
                      <span className="sr-only">(current)</span>
                    )}
                  </Link>
                </li>*/}
                <li
                  className={
                    location.pathname === "/dashboard"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/dashboard">
                    Dashboard
                    {location.pathname === "/dashboard" && (
                      <span className="sr-only">(current)</span>
                    )}
                  </Link>
                </li>
                <li
                  className={
                    location.pathname === "/profile"
                      ? "nav-item active"
                      : "nav-item"
                  }
                >
                  <Link className="nav-link" to="/profile">
                    Profile
                    {location.pathname === "/profile" && (
                      <span className="sr-only">(current)</span>
                    )}
                  </Link>
                </li>
              </>
            )}
            {isAdmin && (
              <li className="nav-item dropdown">
                <a
                  className="nav-link dropdown-toggle"
                  href="/admin"
                  id="adminDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Admin
                </a>
                <div className="dropdown-menu" aria-labelledby="adminDropdown">
                  {/* <Link className="dropdown-item" to="/product/list">
                    Admin Menu
                  </Link> */}
                  <Link className="dropdown-item" to="/admin/users">
                    Manage Users
                  </Link>
                  <Link className="dropdown-item" to="/admin/medals/create">
                    Create Medal
                  </Link>
                </div>
              </li>
            )}
          </ul>
          <div className="form-inline my-2 my-lg-0">
            <a
              href="https://discord.gg/xtqDSm7wBT"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div>
                <img
                  alt="Discord Icon"
                  src="/assets/socials/Discord-Symbol-White.png"
                  className="discord-icon"
                />
              </div>
            </a>

            {token === "" ? (
              <button
                type="button"
                className="btn btn-login"
                onClick={() => {
                  setDestinyRoute(location.pathname);
                  navigate("/login");
                }}
              >
                Login
              </button>
            ) : (
              <button
                type="button"
                className="btn btn-logout"
                onClick={() => {
                  setToken({
                    token: "",
                    username: "",
                    isAdmin: false,
                  });
                  localStorage.removeItem("token");
                }}
              >
                Logout
              </button>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};

export default NavBar;
